import React from 'react'
import { useSelector } from 'react-redux'
import { getCurPatientData } from 'stores/Account/Select'
import _ from 'lodash'
import styles from './styles.js'
import { localization } from './localization'
import withLocalization from '@web/helpers/localizationUtils'

const PrintFooter = props => {
  const { t } = props
  const curPatientData = useSelector(getCurPatientData)
  const id = _.get(props, 'id', 'medication')
  const curPage = _.get(props, 'curPage', '0')
  const totalPage = _.get(props, 'totalPage', '0')
  return (
    <div className="print-footer" >
      <div style={styles.disclaimer}>
        {t(`${id}_disclaimer`)}
      </div>
      <div style={styles.divider}/>
      <div style={styles.footerBottom}>
        <div>{t(`${id}_record`)} {_.get(curPatientData, 'firstname')} {_.get(curPatientData, 'lastname')}, {`${t('dob')} `}{_.get(curPatientData, 'birthDate', '-').replaceAll('-', '/')}</div>
        <div style={styles.pageNumber}>{`${t('page')} ${curPage} ${t('of')} ${totalPage}`}</div>
      </div>
    </div>
  )
}

export default withLocalization(PrintFooter, localization)

